import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  IoPersonOutline, 
  IoCalendarOutline, 
  IoMedicalOutline, 
  IoDocumentTextOutline, 
  IoLocationOutline, 
  IoChatbubbleOutline, 
  IoExitOutline 
} from "react-icons/io5";

// Menu items configuration
const MENU_ITEMS = [
  { id: "1", title: "Meu Perfil", icon: "person-outline", path: "/perfil", IconComponent: IoPersonOutline },
  { id: "2", title: "Agendamentos", icon: "calendar-outline", path: "/agendamentos", IconComponent: IoCalendarOutline },
  { id: "3", title: "Vacinas", icon: "medical-outline", path: "/vacinas", IconComponent: IoMedicalOutline },
  { id: "4", title: "Exames", icon: "document-text-outline", path: "/exames", IconComponent: IoDocumentTextOutline },
  { id: "5", title: "Unidades", icon: "location-outline", path: "/unidades", IconComponent: IoLocationOutline },
  { id: "6", title: "Fale Conosco", icon: "chatbubble-outline", path: "/contato", IconComponent: IoChatbubbleOutline },
  { id: "7", title: "Sair", icon: "exit-outline", path: "/", IconComponent: IoExitOutline },
];

// Styles
const styles = {
  containerProvider: {
    minHeight: "100vh",
    backgroundColor: "#000000",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    flex: 1,
    backgroundColor: "#f5f5f5",
    minHeight: "calc(100vh - 60px)",
  },
  navbar: {
    backgroundColor: "#137a7f",
    padding: "16px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  navbarTitle: {
    color: "white",
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
  },
  gridContainer: {
    padding: "8px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  gridRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "8px",
  },
  gridItem: {
    flex: "1 1 calc(50% - 8px)",
    minWidth: "calc(50% - 8px)",
    backgroundColor: "#fff",
    borderRadius: "15px",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    borderWidth: "1px",
    borderColor: "#e0e0e0",
    borderStyle: "solid",
    cursor: "pointer",
    transition: "transform 0.2s, box-shadow 0.2s",
  },
  gridItemHover: {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
  },
  iconContainer: {
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: "32px",
    color: "#137a7f",
  },
  gridTitle: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#137a7f",
    textAlign: "center",
    marginTop: "auto",
  },
  footer: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
    textAlign: "center",
    borderTopWidth: "1px",
    borderTopColor: "#e0e0e0",
    borderTopStyle: "solid",
  },
  footerText: {
    fontSize: "12px",
    color: "#666",
    margin: 0,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "20px",
    width: "90%",
    maxWidth: "400px",
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#137a7f",
    marginBottom: "20px",
    textAlign: "center",
  },
  modalButtons: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
  },
  modalButton: {
    padding: "10px 20px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },
  modalButtonCancel: {
    backgroundColor: "#f0f0f0",
    color: "#666",
  },
  modalButtonConfirm: {
    backgroundColor: "#e74c3c",
    color: "white",
  },
};

// Web Storage wrapper (using localStorage instead of AsyncStorage)
const storage = {
  getAllKeys: () => {
    try {
      return Object.keys(localStorage);
    } catch (error) {
      //console.error('Error getting all keys from localStorage:', error);
      return [];
    }
  },
  multiRemove: (keys) => {
    try {
      keys.forEach(key => localStorage.removeItem(key));
    } catch (error) {
      //console.error('Error removing multiple items from localStorage:', error);
    }
  }
};

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            left: "20px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          ← <span style={{ fontSize: "14px" }}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer style={styles.footer}>
      <p style={styles.footerText}>© {currentYear} - Sistema de Saúde</p>
    </footer>
  );
};

// Modal Component
const ConfirmModal = ({ visible, title, message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{title}</h3>
        <p style={{ textAlign: "center", marginBottom: "20px" }}>{message}</p>
        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonCancel }}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonConfirm }}
            onClick={onConfirm}
          >
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

// Menu Item Component
const MenuItem = ({ item, onPress }) => {
  const [isHovered, setIsHovered] = useState(false);
  const IconComponent = item.IconComponent;

  return (
    <div
      style={{
        ...styles.gridItem,
        ...(isHovered ? styles.gridItemHover : {}),
      }}
      onClick={() => onPress(item)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.iconContainer}>
        <IconComponent style={styles.icon} />
      </div>
      <div style={styles.gridTitle}>{item.title}</div>
    </div>
  );
};

// Main App Component
const MenuScreen = () => {
  const navigate = useNavigate();
  const [showExitModal, setShowExitModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Function to clear localStorage while preserving reports
  const clearStoragePreservingReports = () => {
    try {
      const allKeys = storage.getAllKeys();

      // Filter keys that are NOT exam reports (PED_COD)
      // Adjust this logic based on your key patterns
      const keysToRemove = allKeys.filter((key) => {
        // Keep keys that are report codes (assuming they're just numbers)
        // You can customize this logic
        return !key.match(/^\d+$/);
      });

      // Remove only filtered keys
      if (keysToRemove.length > 0) {
        storage.multiRemove(keysToRemove);
      }

      //console.log("localStorage cleared successfully! (Reports preserved)");
      return true;
    } catch (error) {
      //console.log("Could not clear localStorage:", error);
      return false;
    }
  };

  const handlePress = async (item) => {
    if (item.title === "Sair") {
      setShowExitModal(true);
    } else {
      navigate(item.path);
    }
  };

  const handleLogout = () => {
    setIsLoading(true);
    setShowExitModal(false);
    
    const success = clearStoragePreservingReports();
    
    // Navigate to login regardless of success
    navigate("/");
    
    setIsLoading(false);
  };

  const handleCancelLogout = () => {
    setShowExitModal(false);
  };

  // Organize items into rows for grid layout
  const gridRows = [];
  for (let i = 0; i < MENU_ITEMS.length; i += 2) {
    gridRows.push(MENU_ITEMS.slice(i, i + 2));
  }

  if (isLoading) {
    return (
      <div style={styles.containerProvider}>
        <div style={styles.container}>
          <NavBar title="Saúde na Palma da Mão" showBackButton={false} />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "40px", minHeight: "400px" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{
                width: "40px",
                height: "40px",
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #137a7f",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto",
              }} />
              <p style={{ marginTop: "20px", color: "#666" }}>Saindo do sistema...</p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={styles.containerProvider}>
      <div style={styles.container}>
        <NavBar title="Saúde na Palma da Mão" showBackButton={false} />
        
        <div style={styles.gridContainer}>
          {gridRows.map((row, rowIndex) => (
            <div key={rowIndex} style={styles.gridRow}>
              {row.map((item) => (
                <MenuItem
                  key={item.id}
                  item={item}
                  onPress={handlePress}
                />
              ))}
              {/* Add empty space if row has only one item */}
              {row.length === 1 && (
                <div style={{ flex: 1, minWidth: "calc(50% - 8px)" }} />
              )}
            </div>
          ))}
        </div>
      </div>
      
      <Footer />
      
      <ConfirmModal
        visible={showExitModal}
        title="Sair"
        message="Deseja realmente sair?"
        onConfirm={handleLogout}
        onCancel={handleCancelLogout}
      />
      
      {/* Add keyframes animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MenuScreen;